import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { COPY } from "./i18n";
import { Preloader } from "./components/Preloader";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Countdown } from "./components/Countdown";
import { Products } from "./components/Products";
import { Lookbook } from "./components/Lookbook";
import { Manifesto } from "./components/Manifesto";
import { Footer } from "./components/Footer";
import { SoundToggle } from "./components/SoundToggle";
import { FloatingBuddy } from "./components/FloatingBuddy";
import { toast } from "sonner";
import axios from "axios";

function App() {
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState("pl");
  const [modalOpen, setModalOpen] = useState(false);
  const t = COPY[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("grain");
    return () => document.documentElement.classList.remove("grain");
  }, []);

  const finishLoading = useCallback(() => setLoading(false), []);
  const openSignup = useCallback(() => setModalOpen(true), []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");
    const sessionId = params.get("session_id");
    if (!payment) return;
    window.history.replaceState({}, "", window.location.pathname);
    if (payment === "cancel") {
      toast.info(t.products.buy.cancel);
      return;
    }
    if (payment === "success" && sessionId) {
      const poll = async (tries = 0) => {
        try {
          const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/payments/status/${sessionId}`);
          if (data.payment_status === "paid") {
            toast.success(t.products.buy.success);
          } else if (tries < 10) {
            setTimeout(() => poll(tries + 1), 2000);
          }
        } catch {
          if (tries < 10) setTimeout(() => poll(tries + 1), 2000);
        }
      };
      poll();
    }
  }, [t]);

  return (
    <div className="App">
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111114", border: "1px solid rgba(217,107,67,0.5)", color: "#F4F1EA", borderRadius: 0, fontFamily: "'JetBrains Mono', monospace" } }} />
      <AnimatePresence>{loading && <Preloader onDone={finishLoading} />}</AnimatePresence>

      {!loading && (
        <>
          <Navbar t={t} lang={lang} setLang={setLang} onSignup={openSignup} />
          <main>
            <Hero t={t} onSignup={openSignup} />
            <Marquee items={["$IGN UP!", "DROP 003", "SMOKE HASH STACK CASH", "NO RESTOCKS"]} />
            <Countdown t={t} />
            <Products t={t} lang={lang} modalOpen={modalOpen} setModalOpen={setModalOpen} />
            <Lookbook t={t} />
            <Manifesto t={t} />
            <Marquee items={["14.09 — 14:20 CEST", "SMOKE HASH STACK CASH", "ONE TEE ONLY", "MAROKO VIBE"]} fast gold />
          </main>
          <Footer t={t} lang={lang} />
          <SoundToggle />
          <FloatingBuddy />
        </>
      )}
    </div>
  );
}

export default App;
